import { render, staticRenderFns } from "./mainData.vue?vue&type=template&id=823eb7e4"
import script from "./mainData.vue?vue&type=script&lang=js"
export * from "./mainData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports